import { useEffect } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Lock, Home, LogIn } from "lucide-react";

export default function Error403() {
  useEffect(() => {
    // Log error to analytics if available
    console.error("403 Error page loaded");
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-teal-50 to-amber-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-white/90 backdrop-blur shadow-xl border-purple-200 p-8">
        <div className="text-center space-y-6">
          <div className="mx-auto w-20 h-20 bg-gradient-to-br from-purple-600 to-teal-600 rounded-full flex items-center justify-center">
            <Lock className="w-12 h-12 text-white" />
          </div>
          
          <div className="space-y-2">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-teal-600 bg-clip-text text-transparent">
              Access Denied
            </h1>
            <p className="text-gray-600">
              You don't have permission to access this magical story realm.
            </p>
          </div>

          <div className="bg-purple-50 rounded-lg p-4">
            <p className="text-sm text-purple-700">
              <strong>Error 403:</strong> Forbidden
            </p>
            <p className="text-xs text-purple-600 mt-1">
              This page requires special permissions or a subscription.
            </p>
          </div>

          <div className="space-y-3">
            <Link href="/auth">
              <Button className="w-full bg-gradient-to-r from-purple-600 to-teal-600 hover:from-purple-700 hover:to-teal-700">
                <LogIn className="mr-2 h-4 w-4" />
                Sign In
              </Button>
            </Link>
            
            <Link href="/home">
              <Button variant="gradient" className="w-full text-white">
                <Home className="mr-2 h-4 w-4" />
                Go Home
              </Button>
            </Link>
          </div>

          <p className="text-xs text-gray-500">
            Need help? Contact support@SnuggleCrafters.com
          </p>
        </div>
      </Card>
    </div>
  );
}